import { useTranslation } from 'react-i18next';
import type { IArticleNutritionFactDto } from '~/dtos/hub/hub.models.generated';
import { cn } from '~/common/utils/styleUtil';
import { useScreenSize } from '~/common/hooks/useScreenSize.ts';

interface NutritionListProps {
  nutrition: IArticleNutritionFactDto;
}

export const nutritionalValues: { valueKey: string; labelKey: string }[] = [
  { valueKey: 'energyKj', labelKey: 'Energie kJ' },
  { valueKey: 'energyKcal', labelKey: 'Energie kcal' },
  { valueKey: 'fat', labelKey: 'Fett' },
  { valueKey: 'saturatedFatty', labelKey: 'davon gesättigte Fettsäuren' },
  {
    valueKey: 'monoUnsaturatedFatty',
    labelKey: 'davon einfach ungesättigte Fettsäuren'
  },
  {
    valueKey: 'polyUnsaturatedFatty',
    labelKey: 'davon mehrfach ungesättigte Fettsäuren'
  },
  { valueKey: 'carbohydrates', labelKey: 'Kohlenhydrate' },
  { valueKey: 'sugar', labelKey: 'davon Zucker' },
  { valueKey: 'dietaryFibres', labelKey: 'Ballaststoffe' },
  { valueKey: 'protein', labelKey: 'Eiweiss' },
  { valueKey: 'salt', labelKey: 'Salz' }
];

export function NutritionList({ nutrition }: Readonly<NutritionListProps>) {
  const { t } = useTranslation();
  const { isMobile } = useScreenSize();

  return (
    <table className={'w-full border-collapse mb-2'}>
      <thead>
        <tr>
          <th className={'hidden desktop:block desktop:w-[300px]'} />
          <th colSpan={isMobile ? 2 : 1} className={'px-4 text-right desktop:text-left'}>
            {t('100 g / 100 ml enthalten im Durchschnitt')}
          </th>
        </tr>
      </thead>
      <tbody>
        {nutritionalValues.map(value => {
          let nutritionValue = nutrition[value.valueKey];
          if (!nutritionValue) {
            nutritionValue = t('k.A.');
          }
          const indentRow =
            value.valueKey === 'saturatedFatty' ||
            value.valueKey === 'monoUnsaturatedFatty' ||
            value.valueKey === 'polyUnsaturatedFatty' ||
            value.valueKey === 'sugar';
          return (
            <tr key={value.valueKey} className={'border-t h-[50px]'}>
              <td className={cn('px-0 w-2/3 desktop:w-[300px] py-1', indentRow && 'pl-6')}>
                <h3 className={'text-base font-normal'}>{t(value.labelKey as any)}</h3>
              </td>
              <td
                className={'px-4 text-right desktop:text-left'}
                id={'product-info-cell-' + value.valueKey}
                data-testid={`nutrition-${value.labelKey}`}
              >
                {nutritionValue}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
